import { useLoginContext } from "../../../App";
import { createWidgetTemplate, deleteWidgetTemplate, fetchAllWidgetTemplates, fetchWidgetTemplate, updateWidgetTemplate } from "../../../services/b2b-reporting-apiServices";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";
import { useContentContext } from "../../layout/Layout";

const useWidgetTemplates = () => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-reporting');
    
    const getAllWidgetTemplates = async () => {
        try {
            const response = await fetchAllWidgetTemplates(loginData.accessToken);
            return response;
        } catch (error) {
            console.error('Error fetching widget templates: ' + error.message);
            setNotification({
                message: t('Error fetching widget templates: ') + error.message,
                type: 'error',
                duration: 5000,
            });
        }
    }

    const getWidgetTemplate = async (widgetTemplateId) => {
        try {
            const response = await fetchWidgetTemplate(loginData.accessToken, widgetTemplateId);
            return response;
        } catch (error) {
            console.error('Error fetching widget template: ' + error.message);
            setNotification({
                message: t('Error fetching widget template: ') + error.message,
                type: 'error',
                duration: 5000,
            });
        }
    }

    const newWidgetTemplate = async (widgetTemplateDTO) => {
        try {
            const response = await createWidgetTemplate(loginData.accessToken, widgetTemplateDTO);
            return response;
        } catch (error) {
            console.error('Error creating widget template: ' + error.message);
            setNotification({
                message: t('Error creating widget template: ') + error.message,
                type: 'error',
                duration: 5000,
            });
        }
    }

    const updateTheWidgetTemplate = async (widgetTemplateDTO) => {
        try {
            const response = await updateWidgetTemplate(loginData.accessToken, widgetTemplateDTO);
            return response;
        } catch (error) {
            console.error('Error updating widget template: ' + error.message);
            setNotification({
                message: t('Error updating widget template: ') + error.message,
                type: 'error',
                duration: 5000,
            });
        }
    }

    const deleteTheWidgetTemplate = async (widgetTemplateId) => {
        try {
            const response = await deleteWidgetTemplate(loginData.accessToken, widgetTemplateId);
            return response;
        } catch (error) {
            console.error('Error deleting widget template: ' + error.message);
            setNotification({
                message: t('Error deleting widget template: ') + error.message,
                type: 'error',
                duration: 5000,
            });
        }
    }

    return { getAllWidgetTemplates, getWidgetTemplate, newWidgetTemplate, updateTheWidgetTemplate, deleteTheWidgetTemplate };
}

export default useWidgetTemplates;